import React from 'react';

import { USER_TYPES } from 'dpl/shared/constants/shared';
import SignupFormContainer from 'dpl/containers/SignupFormContainer';

export default function UserAuthSignupForm() {
  return (
    <div className="UserAuthSignupForm">
      <h1 className="mb10 f6">Sign up for Good Dog</h1>

      <SignupFormContainer
        userType={USER_TYPES.BUYER}
        buttonClassName="button button--primary ph7 pv2 center"
        buttonText="Sign up"
      />
    </div>
  );
}
